import { useState } from "react";
import { useBooks } from "@/hooks/use-sheets-data";
import { CategorySidebar } from "@/components/books/category-sidebar";
import { BookGrid } from "@/components/books/book-grid";
import { Button } from "@/components/ui/button";
import { useAnalytics } from "@/hooks/use-analytics";
import { Link } from "react-router-dom";

export function BookList() {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const { data: books = [], isLoading } = useBooks();
  useAnalytics();

  const filteredBooks = books.filter((book) => {
    if (selectedCategory === "all") return true;
    if (!book.category) return false;
    
    // Handle case where category might be an array
    const categories = Array.isArray(book.category)
      ? book.category
      : typeof book.category === 'string'
        ? book.category.split(';').map(c => c.trim())
        : [];
        
    return categories.map(c => c.toLowerCase()).includes(selectedCategory.toLowerCase());
  });

  const booksPerPage = 12;
  const totalPages = Math.ceil(filteredBooks.length / booksPerPage);
  const currentBooks = filteredBooks.slice(
    (currentPage - 1) * booksPerPage,
    currentPage * booksPerPage
  );

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <p className="text-xl text-muted-foreground">Loading books...</p>
      </div>
    );
  }

  return (
    <div className="-mx-6 -mt-6 min-h-[calc(100vh-4rem)]">
      <div className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container py-8">
          <h1 className="text-3xl font-bold mb-2">Books</h1>
          <p className="text-muted-foreground">
            Discover the most recommended books from the Bitcoin community
          </p>
        </div>
      </div>

      <div className="container py-8">
        <div className="flex gap-8">
          <CategorySidebar
            selectedCategory={selectedCategory}
            onSelectCategory={setSelectedCategory}
          />
          <div className="flex-1 space-y-8">
            <BookGrid books={currentBooks} />
            
            {totalPages > 1 && (
              <div className="flex justify-center gap-2">
                <Button
                  variant="outline"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                >
                  Previous
                </Button>
                <Button
                  variant="outline"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((p) => p + 1)}
                >
                  Next
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}